export default __webpack_public_path__ + "static/media/logoFooter.207eb9e2.png";